<template>
  <div class="view prequiz">
    
    
    <div :style="statusBarStyle"><p style="font-size: 10px;">Internet Status: {{ internetStatus }}</p></div>
    
    <div v-if="prequiz">
      <squizzy-squid :mouth="activeView.expression.mouth"
      />
      <div v-if="activeView.status" class="status label" :class="{'status-c':statusC}">
        {{ activeView.status }}
      </div>
      <h1 class="page-title" v-if="!isFinished && !leaderBoardState">{{ activeView.title }}</h1>
      <p v-if="activeView.subtitle && !isFinished && !leaderBoardState" class="page-subtitle">
        {{ activeView.subtitle }}
      </p>
      <squizzy-squids v-if="activeView.name === 'welcome'"
          :mouth="activeView.expression.mouth"
      />
      <register-player
          v-if="activeView.name === 'register' && !isFinished"
          @error="setError"
      />
    </div>
    <div v-if="question_view">
      <div class="question-card">
        <div class="progress label">{{ question.question_counter }}</div>
        <question-choices style="margin-top: 30px;
    min-height: 600px;"

                          :question_id="question.id"
                          :countDown="countDown"
                          :choices="choices"
                          :correct_option="question.correct_option"
                          :is-answer-submitted="isAnswerSubmitted"
                          @answered="setPlayerClickedCard"
        />
      </div>
    </div>
    <div v-if="result_view">
      <div style="display: grid;    justify-content: center;">
        <squizzy-squid
            :mouth="activeView.expression.mouth"
        />
        <div v-if="playerAnswer" style="display: flex;
    justify-content: center;
    color: green;
    align-items: center;
    margin: 10px;">
          <!-- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
               width="120" height="120"
               viewBox="0 0 30 30"
               style=" fill:#undefined;">    <path d="M 15 3 C 8.373 3 3 8.373 3 15 C 3 21.627 8.373 27 15 27 C 21.627 27 27 21.627 27 15 C 27 12.820623 26.409997 10.783138 25.394531 9.0214844 L 14.146484 20.267578 C 13.959484 20.454578 13.705453 20.560547 13.439453 20.560547 C 13.174453 20.560547 12.919422 20.455578 12.732422 20.267578 L 8.2792969 15.814453 C 7.8882969 15.423453 7.8882969 14.791391 8.2792969 14.400391 C 8.6702969 14.009391 9.3023594 14.009391 9.6933594 14.400391 L 13.439453 18.146484 L 24.240234 7.3457031 C 22.039234 4.6907031 18.718 3 15 3 z M 24.240234 7.3457031 C 24.671884 7.8662808 25.053743 8.4300516 25.394531 9.0195312 L 27.707031 6.7070312 C 28.098031 6.3150312 28.098031 5.6839688 27.707031 5.2929688 C 27.316031 4.9019687 26.683969 4.9019688 26.292969 5.2929688 L 24.240234 7.3457031 z"></path></svg> -->
        </div>
        <div v-else style="    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;">
          <!-- <img style="" :src="img_url"/> -->
        </div>
        <p class="page-subtitle" style="font-size: 1.8rem;">
          <!-- <p class="feedback-heading tooltip__initiator">{{ feedbackTitle }} -->
        </p>
        <p style="font-size: 2.5rem;">{{points}}</p>
        <p>Waiting for the next question....</p>
      </div>







    </div>
    <div v-if="time_out_view">
      <div style="display: grid;    justify-content: center;">
        <squizzy-squid
            :mouth="activeView.expression.mouth"
        />
        <div style="    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;">
          <img style="" :src="img_url"/>
        </div>



        
        <p class="page-subtitle" style="font-size: 1.8rem;">
          <p class="feedback-heading tooltip__initiator">Sorry Times Up. You took too long to respond.
        </p>
        <p style="font-size: 2.5rem;">0</p>
        <p>Waiting for the next question...</p>
      </div>
    </div>
    <div v-if="end_view">
      <div style="display: grid;    justify-content: center;">
        <squizzy-squid
            :mouth="activeView.expression.mouth"
        />
        <p class="page-subtitle" style="font-size: 1.8rem;">
          Trivia has ended
        </p>
        <p style="margin-bottom: 30px;">Thank you for playing</p>
        <squizzy-squids
            :mouth="activeView.expression.mouth"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./general/Button";
import QuestionImage from "./question/QuestionImage";
import QuestionChoices from "./question/QuestionChoices";
import SquizzySquid from "./general/Gigly";
import SquizzySquids from "./general/SquizzySquid";
import { htmlEntity } from '../htmlEntityMixin';
import RegisterPlayer from "../components/general/RegisterPlayer";
import axios from 'axios';
import {store} from "@/store/store";
import Vue from "vue";
import CircularJSON from "circular-json";
const Leaderboard = () => import("../components/result/Leaderboard");
const FEEDBACK_WRONG = [
  "That's too bad",
  `Better luck next time...`,
  `No points for you`
];

const FEEDBACK_CORRECT = [
  `You're smashing it`,
  "Congratulations",
  "You are pro at this!",
  "You are incredible",
  `The smartest chap in the room`,
  "Incredible effort",
  "How exquisite",
  `More points for you`,
  `You're cracking it`
];
export default {
  mixins:[htmlEntity],
  components: {
    "n-button": Button,
    QuestionImage,
    QuestionChoices,
    SquizzySquids,
    SquizzySquid,
    RegisterPlayer,
    Leaderboard
  },
  data() {
    return {
      correct:false,
      current_points:0,
      current_question_submitted:false,
      error: false,
      team:0,
      img_url:require("@/assets/red.png"),
      countDown:28,
      playerClickedCard: false,
      result_view:false,
      time_out_view:false,
      question_view:false,
      end_view:false,
      prequiz:true,
      questions:[],
      playImg: require("@/assets/play.svg"),
      plusImg: require("@/assets/plus.svg"),
      resultImg: require("@/assets/result.svg"),
      internetStatus: 'Checking...',
      statusBarColor: 'transparent', // Initial color is transparent (hidden)
      lastPingTime: null,
      pingInterval: null,
    };
  },
  mounted()
  {
    let context = this;
    // var pusher = new Pusher('60b70543fe2e5f6aaf34', {
    //   cluster: 'ap1'
    // });
    // pusher.logToConsole = true;

    // var channel = CircularJSON.parse(localStorage.getItem("channel"));
    // const channelString = localStorage.getItem("channel");
    // const channel = CircularJSON.parse(channelString);
    // const channel = pusher.subscribe('tuni-clear-abyss');
    // const channel = store.state.channel;
    // console.log(channel);

    // channel.bind('members_joined', function(data) {
    //   if (data.trivia_id == context.$store.state.player.matchSlug) {
    //     context.team = data.members;
    //   }
    // });

    Echo.channel("tuni-clear-abyss").listen("TriviaMembersJoined", (datas) => {
      let data = datas.members_joined;
         if (data.trivia_id == context.$store.state.player.matchSlug) {
          console.log('memebr join');
        context.team = data.members;
      }
    });
    // channel.bind('trivia_ended', function(data) {
    //   if (data.trivia_id == context.$store.state.player.matchSlug && context.playerClickedCard == false){
    //     context.result_view=false;
    //     context.question_view=false;
    //     context.prequiz =false;
    //     context.end_view =true;
    //     localStorage.removeItem("channel")
    //   }
    // });
    Echo.channel("tuni-clear-abyss").listen("TriviaEndGame", (datas) => {
      let data = datas.data;
        if (data.trivia_id == context.$store.state.player.matchSlug && context.playerClickedCard == false){
          console.log('end game');
        context.result_view=false;
        context.question_view=false;
        context.prequiz =false;
        context.end_view =true;
      }
    });
    // channel.bind('next_question_live',function (data){
    //   if (data.trivia_id == context.$store.state.player.matchSlug) {
    //     context.playerClickedCard = false;
    //     context.result_view = false;
    //     context.question_view = true;
    //     context.prequiz = false;
    //     context.end_view = false;
    //     context.$store.commit('question', data);
    //     // console.log(data)
    //   }
    // });
    Echo.channel("tuni-clear-abyss").listen("TriviaNextQuestionLive", (datas) => {
      // console.log(context.$store.state.player.matchSlug);
      let data = datas.data;
        if (data.trivia_id == context.$store.state.player.matchSlug && context.playerClickedCard == false){
          console.log('question live');
          context.playerClickedCard = false;
        context.result_view = false;
        context.question_view = true;
        context.prequiz = false;
        context.end_view = false;
        context.$store.commit('question', data);
      }
    });
    // channel.bind('trivia_answer_leaderboard',function (data){
    //   if (data.trivia_id == context.$store.state.player.matchSlug && context.$store.state.questionWasAnswered) {
    //     context.playerClickedCard = false;
    //     context.result_view = true;
    //     context.time_out_view = false;
    //     context.question_view = false;
    //     context.prequiz = false;
    //     context.end_view = false;
    //   }else{
    //     context.playerClickedCard = false;
    //     context.result_view = false;
    //     context.time_out_view = true;
    //     context.question_view = false;
    //     context.prequiz = false;
    //     context.end_view = false;
    //   }
    // });

    Echo.channel("tuni-clear-abyss").listen("TriviaAnswerLeaderBoard", (datas) => {
      let data = datas.data;
      if (data.trivia_id == context.$store.state.player.matchSlug && context.$store.state.questionWasAnswered) {
        console.log('leaderboard true');
        context.playerClickedCard = false;
        context.result_view = true;
        context.time_out_view = false;
        context.question_view = false;
        context.prequiz = false;
        context.end_view = false;
      }else{
        console.log('leaderboard false');
        context.playerClickedCard = false;
        context.result_view = false;
        context.time_out_view = true;
        context.question_view = false;
        context.prequiz = false;
        context.end_view = false;
      }
    });
    this.pingInterval = setInterval(this.checkInternetStability, 60000); // Change to 1 minute (60000 ms)

  },
  beforeDestroy() {
    clearInterval(this.pingInterval);
  },
  computed: {
    statusBarStyle() {
      return {
        height: 'fit-content',
        width: '100%',
        backgroundColor: this.statusBarColor,
        transition: 'background-color 0.3s ease',
        color: 'white',
      };
    },
    feedbackTitle() {

      const maxWrong = FEEDBACK_WRONG.length;
      // console.log(maxWrong);
      const maxCorrect = FEEDBACK_CORRECT.length;
      // console.log(maxCorrect);


      // Get a random feedback sentence for wrong answers
      const randomWrong = Math.floor(Math.random() * maxWrong);
      // Get a random feedback sentence for correct answer
      const randomCorrect = Math.floor(Math.random() * maxCorrect);
      // Get the status of the player's answer from the store
      const playerAnswer = this.playerAnswer;

      // console.log(playerAnswer);
      // Select feedback sentence based on player answer

      return playerAnswer
          ? `Correct! ${FEEDBACK_CORRECT[randomCorrect]}`
          : `Wrong! ${FEEDBACK_WRONG[randomWrong]}`;
    },
    playerAnswer() {

      return this.$store.state.playerAnswer

    },
    points() {
      return this.$store.state._points
    },
    player_id()
    {
      return this.$store.state.scores.playerOne.id;
    },
    challenge_id()
    {
      return this.$store.state.challenge_id;
    },
    passed()
    {
      return this.$store.state.finish_passed;
    },
    failed()
    {
      return this.$store.state.finish_failed;
    },
    next()
    {
      return this.$store.state.finish_next;
    },
    score()
    {
      return this.$store.state.finish_score;
    },
    team_score()
    {
      return this.$store.state.finish_team_score;
    },
    loading()
    {
      return this.$store.state.finish_loading;
    },
    completed_challenge()
    {
      return this.$store.state.finish_completed_challenge;
    },
    belongs_to_challenge()
    {
      return this.$store.state.finish_belongs_to_challenge;
    },
    teamMode()
    {
      return this.$store.state.team_mode;
    },
    url()
    {
      return window.location.search.substring(1);
    },
    btnText()
    {
      if(this.passed)
      {
        if (this.completed_challenge)
        {
          return "Challenge Results";

        }else
        {
          if (this.$store.state.challenge_id=="40")
          {
            return "Watch Now";
          }else
          {
            return "Next Level";
          }

        }

      }else {
        return "Retry";
      }
    },
    //score()
   // {
   //   return this.$store.state.scores.playerOne.total;
    //},
    player()
    {
      return this.$store.state.player;
    },
    isFinished() {
      return this.$store.state.isFinished;
    },
    leaderBoard() {
      return this.$store.state.leaderBoard;
    },
    leaderBoardState() {
      return this.$store.state.leaderBoard;
    },
    match() {
      return this.$store.state.questions;
    },
    checkout() {
      return this.$store.state.checkout;
    },
    status() {
      //const player = this.$store.state.player;
      return this.activeView.name !== "lobby"
        ? `${this.isFinished ? "Joined" : "Joined"}: "BLAZE"`
        : "Powered by GIG";
    },
    statusC(){
      return this.$store.state.flushMessages;
    },
    activeView() {
      // Get the player object from the store
      const player = this.$store.state.player;
      // Quiz title
      let title;
      const error = this.$store.state.flushMessages;

      const checkout = this.$store.state.checkout;

      if (this.leaderBoard && !checkout)
        return {
          name: "LeaderBoard",
          title: "Thank you for playing!",
          expression: { mouth: "happy" }
        };
      if (checkout)
        if(this.kako)
        {
          return {
            name: "Finished",
            title: "Level Completed!",
            expression: { mouth: "happy" }
          };
        }else
        {
          return {
            name: "Finished",
            title: "Thank you for playing!",
            expression: { mouth: "happy" }
          };
        }

      if (!player && error)
        return {
          name: "register",
          status: error,
          expression: { eyes: "happy", mouth: "default" }
        };
      // Register for match if no Player
      if (!player)
        return {
          name: "register",
          status: title,
          expression: { eyes: "happy", mouth: "default" }
        };

      return {
        name: "welcome",
        title: `Hello ${player.name}!`,
        subtitle: "Game is about to start. Hold on as other players join...Ensure you are on stable internet",
        status: `Joined: ${player.title}`,
        expression: { eyes: "default", mouth: "happy" }
      };
    },

    playerCount() {
      return this.$store.state.playersCount;
    },
    slug()
    {
      return this.$store.state.matchSlug;
    },
    isAnswerSubmitted() {
      if (this.playerClickedCard) {
        // shortcut for a more snappy client experience
        return true;
      }
      return false;
    },
    decodedQuestion() {
      return this.decode(this.question.question);
    },
    question_image()
    {
      return this.decode(this.question.image_url);
    },
    question() {
      return this.$store.state.question;
    },
    choices() {
      return this.question.question_options;
    },

  },
  methods: {
    setPlayerClickedCard() {
      this.playerClickedCard = true;
      const vm = this;
      setTimeout(function () {
          vm.$store.commit('playerClickedCard', false);
          vm.result_view=true;
          vm.question_view=false;
          vm.prequiz =false;
          vm.end_view =false;
          // vm.current_question_submitted =true;
          // vm.$store.commit('setResults', true);
        }, 1500);

    },
    leaveMatch() {
      this.$store.commit("resetGame",false);
      this.$store.commit("setIsOnBreak");
      this.$store.commit("setMystery");
      this.$store.commit('setResults',false);
      this.$store.commit('setCheckout',false);
      this.$confetti.stop();
      window.location.href = process.env.VUE_APP_FRONT_SITE_URL;
    },
    playBaze()
    {
        let url= '';

        window.open(url,"_blank");
    },
    buyFiftyFifty()
    {
      window.open("https://fiftyfiftyboardgame.com/product/50-50-kenyan-board-game","_blank");
    },
    gotocopia()
    {
      window.open("https://copia.co.ke","_blank")
    },
    replay()
    {
      window.open("https://tunitrivia.fun/trivia/596/play","_blank")
    },
    createTrivia()
    {
      window.open("https://client.tunitrivia.com","_blank");
    },
    viewResults() {
      if (this.teamMode ===1)
      {
        window.location.href = "https://tunitrivia.fun/trivia/"+this.slug+"/results/team?isp="+this.$store.state.isp;

      }else {
        window.location.href = "https://tunitrivia.fun/trivia/"+this.slug+"/results?isp="+this.$store.state.isp;

      }
    },
    nextLevel() {
      window.location.href = this.next;
    },
    moreTrivia()
    {
      window.location.href = "https://tinyurl.com/PlayMoreTuniTrivia";//"https://tunitrivia.fun?isp="+this.$store.state.isp;
    },
    finish()
    {
      this.$store.commit("setCheckout",true)
      let context = this;
      const api = "https://create.tunitrivia.com/api/challenge/trivia/player/complete";
      const qs = require('qs')
      axios({
        method: 'post',
        url: api,
        data: qs.stringify({
          'trivia_id': this.$store.state.matchSlug,
          'player_id': this.$store.state.scores.playerOne.id,
          'user_id':this.$store.state.user_id,
          'isp':this.$store.state.isp
        }),
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
      }).then(response => {
        context.$store.commit('FINISH_THE_GAME',  {
          loading:false,
          score : response.data.data.points,
          team_score : response.data.data.team_average,
          passed : response.data.passed,
          next :  response.data.next_trivia_link,
          failed : response.data.failed_message,
          completed_challenge : response.data.completed_challenge,
          belongs_to_challenge : response.data.belongs_to_challenge
        })
        context.$store.loading=false;
        context.$store.score = response.data.data.points;
        context.$store.team_score = response.data.data.team_average;
        context.$store.passed = response.data.passed;
        context.$store.next =  response.data.next_trivia_link;
        context.$store.failed = response.data.failed_message;
        context.$store.completed_challenge = response.data.completed_challenge;
        context.$store.belongs_to_challenge = response.data.belongs_to_challenge;
      })
    },
    setError(error) {
      this.error = error;
    },

    registerExistingPlayer() {
      return this.$store
        .dispatch("registerExistingPlayer")
        .then(response => {
          if (!response) {
            this.error = "Something went wrong, please try again.";
            this.$emit("error", this.error);
          } else {
            this.error = false;
            this.$emit("error", false);
          }
        });
    },
    // async checkInternetStability() {
    //   const startTime = performance.now();
    //   try {
    //     const response = await axios.get('https://create.tuni.ke/api/ping');
    //     const endTime = performance.now();
    //     const duration = endTime - startTime;
        
    //     this.evaluateInternetStability(duration);
    //   } catch (error) {
    //     this.internetStatus = 'Poor internet connection';
    //     this.statusBarColor = 'red'; // Show red bar on error
    //   }
    // },
    evaluateInternetStability(duration) {
      if (this.lastPingTime !== null) {
        const timeDifference = Math.abs(duration - this.lastPingTime);
        if (timeDifference > 500 || duration > 1000) { 
          this.internetStatus = 'Poor internet connection';
          this.statusBarColor = 'red'; // Show red bar for poor connection
        } else {
          this.internetStatus = 'Good internet connection';
          this.statusBarColor = 'green'; // Show green bar for good connection
        }
      } else {
        this.internetStatus = 'Good internet connection';
        this.statusBarColor = 'green'; // Show green bar for good connection
      }
      this.lastPingTime = duration;
    },
  }
};
</script>

<style lang="sass" scoped>
.lastIcon
  width: 10px
  margin-right: 4px
.prequiz
  display: grid
  grid-template-rows: repeat(4, min-content) auto

.status
  padding-top: 0.5rem
.status-c
  color: #E31F27

.match-details
  text-align: center
  padding: 1rem

  .player-count
    font-family: 'Burd Sans', sans-serif
    font-size: 4rem
    @media screen and (max-width: 374px)
      font-size: $font-size-xxlarge

.top-players
  font-size: $font-size-large
  text-align: center
  margin: 1rem 0 0.5rem

.players
  padding-bottom: 1rem
.view-tracker
  justify-self: flex-end
  display: flex
  justify-content: center
  width: 100%
  margin: 0.5rem 0 1rem
.leave-button
  margin: auto
  background-color: #93278f
  border-radius: 50px
  color: white
  padding: 15px 32px
  text-align: center
  text-decoration: none
  display: inline-block
  font-size: 16px

  .leave-label
    font-family: 'Burd Sans', sans-serif
    padding-right: 0.25rem

  .leave-icon svg
    display: flex
    height: 1.5em
    fill: #ff020a
</style>
